import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IHistoryFeature } from './history.feature.state';
import { getFailures, getIsLoading, getIsSkeletonLoading, getOrderHistory } from './history.selectors';
import { ClearStateAction, GetOrderHistoryAction, setLoading, setSkeletonLoading } from './history.actions';
import { RequestHistoryParams } from '../models';

@Injectable()
export class HistoryFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public isSkeletonLoading$ = this.store.select(getIsSkeletonLoading);
  public failures$ = this.store.select(getFailures);
  public orderHistory$ = this.store.select(getOrderHistory);

  constructor(private store: Store<IHistoryFeature>) {}

  public getOrderHistory(params: RequestHistoryParams, showLoading = true): void {
    this.store.dispatch(GetOrderHistoryAction({ params, showLoading }));
  }

  public setLoading(isLoading: boolean): void {
    this.store.dispatch(setLoading({ isLoading }));
  }

  public setSkeletonLoading(isSkeletonLoading: boolean): void {
    this.store.dispatch(setSkeletonLoading({ isSkeletonLoading }));
  }

  public clearState(actionType: string): void {
    this.store.dispatch(ClearStateAction({ actionType }));
  }
}
